import { copyToClipboard } from '@/helpers/copyToClipboard'

const ANIMATION_DURATION = 400
const ANIMATION_DELAY = 400

export default {
  data() {
    return {
      isActive: false,
      isDisabled: false,
    }
  },
  methods: {
    copyText(text) {
      if (!text || this.isDisabled) return

      copyToClipboard(text)
      this.isActive = true
      this.isDisabled = true

      setTimeout(() => {
        this.isActive = false
      }, ANIMATION_DURATION + ANIMATION_DELAY)

      setTimeout(() => {
        this.isDisabled = false
      }, ANIMATION_DURATION * 2 + ANIMATION_DELAY)
    },
  },
}
